import { render, staticRenderFns } from "./fishingParadise.vue?vue&type=template&id=e314001e"
import script from "./fishingParadise.vue?vue&type=script&lang=js"
export * from "./fishingParadise.vue?vue&type=script&lang=js"
import style0 from "./fishingParadise.vue?vue&type=style&index=0&id=e314001e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports